/**
 * @fileoverview AgOpenwinComponent - AG Grid 開窗元件
 * @description
 * 此元件提供基於 AG Grid 的開窗選擇功能，支援單選和多選模式。
 * 可透過彈出對話框方式顯示並進行資料查詢與選擇。
 *
 * @author JK Team
 * @version 2.0.0 - Upgraded to Angular 20
 */
import { Component, EventEmitter, inject, Input, input, OnInit, output, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AgGridModule } from 'ag-grid-angular';
import { MaterialModule, OpenWinLoadOption } from 'jk-service';
import { ColDef, GridApi, GridReadyEvent, RowDoubleClickedEvent, RowSelectionOptions } from 'ag-grid-community';
import { JkBaseComponent } from 'jk-service';
import { CR, idNameItem, jkRestReturn } from 'jk-service';
import { jkLib } from 'jk-service';
import { JkComboboxComponent } from 'jk-service';
import { JkeditComponent } from 'jk-service';
import { qbeCompare } from 'jk-service';
import { AgGridService, openwinColdef } from 'jk-service';
import { jkRestReturnClass, openWinClass } from 'jk-service';
import { JkGridBaseComponent } from '../jkgrid-base.component';


/**
 * @component AgOpenwinComponent
 * @description
 * AG Grid 開窗元件，提供彈出式資料選擇功能。
 * 基於 AG Grid 和 Material Dialog 實現，支援資料查詢、過濾和選擇。
 * 可配置為單選或多選模式，適用於各種資料選擇場景。
 * @extends {JkGridBaseComponent}
 */
@Component({
  selector: 'app-agopenwin',
  templateUrl: './agopenwin.component.html',
  styleUrls: [],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '(window:resize)': 'onWindowResize()',
    '(document:keydown)': 'handleKeyboardEvent($event)',
    '(window:popstate)': 'onPopState($event)'
  },
  imports: [
    AgGridModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    JkComboboxComponent,
    JkeditComponent
],
  providers: [AgGridService],
})
//export class AgOpenwinComponent extends JkBaseComponent implements OnInit {
export class AgOpenwinComponent extends JkGridBaseComponent implements OnInit {
   dialogRef = inject<MatDialogRef<AgOpenwinComponent>>(MatDialogRef);
   retParams = inject(MAT_DIALOG_DATA);

   override comType: string = 'agopenwin';
   orderCompare: idNameItem = {id:'like',name:'前包含',ps1:' like '};
   compareList: idNameItem[] = qbeCompare;
   orderItem: idNameItem = {id:'',name:''};
   orderCompareId: string = 'like%';
   orderWhere: string = '';

  // @Input() properties for external component configuration
  /*
  @Input() maintable: string = '';
  @Input() mainItem: string = '';
  @Input() type: string = 'W';
  @Input() params: any[] = [];
  @Input() valueExpr: string = 'id';
  @Input() displayExpr: string = 'name';
  @Input() height: number = window.innerHeight - 20;
  @Input() value: any;
  // Convert @Output() to output() signals
  valueChange = output<any>();
  selectedRows = output<any[]>();
  private _isMultiSelect = false;
  columnDefs: ColDef[] = [];
  openwinIn = new openWinClass();
  itemList: any[] = [];
  selectedRowsData: any[] = [];
  selectionFilter: any[] = [];
  _keyExpr: string[] = [];
  focusedRowIndex: number = 0;
  focusedRowKey: any = undefined;
  fields!: Array<any>;
  gridFilterValue: string = '';
  selectedItem: any;
  defaultColDef: ColDef = {};
  */
  // TODO: Skipped for migration because:
  //  Your application code writes to the input. This prevents migration.
  @Input() expireDay: number = 0;
  isOk = output<boolean>();
  onOkClick = output<any>({alias: 'onOkClick'});

  // Internal properties
  sqlOrder: string = '';
  sqlWhere: string = '';
  openwinOut = new openWinClass();
  tempList: any[] = [];
  columnLabel: any = {};
  columns: any[] = [];
  okVisible: boolean = false;

  // Services injected using constructor
  public override gridSrv: AgGridService = inject(AgGridService);
  // Convert getter/setter for keyExpr
  override set keyExpr(value: string[]) {
    this._keyExpr = value;
  }
  override get keyExpr(): string[] {
    return this._keyExpr;
  }

  // Convert getter/setter for gridApi
  override set gridApi(value: GridApi) {
    if (this.gridSrv) this.gridSrv.gridApi = value;
    else alert('jkaggrid.gridSrv is null');
  }
  override get gridApi(): GridApi {
    return this.gridSrv.gridApi;
  }

  ret: jkRestReturn = new jkRestReturnClass();

  constructor() {
    super();
    let dialogParams = this.retParams.obj;

    // Set @Input() properties from dialog data
    this.maintable = dialogParams.maintable || '';
    this.mainItem = dialogParams.item || '';
    this.type = dialogParams.type || 'W';
    this.params = dialogParams.params || [];
    this.valueExpr = dialogParams.valueExpr || 'id';
    this.displayExpr = dialogParams.displayExpr || 'name';
    this.expireDay = dialogParams.expireDay || 0;
    this.heightChange(dialogParams.height || (window.innerHeight - 20));

    // Set component properties
    this.isMultiSelect = dialogParams.isMultiSelect || false;

    jkLib.cloneField(openwinColdef, this.defaultColDef);
    this.onDoOk.bind(this);
    this.onPopState.bind(this);

    // Validation
    if (this.maintable === '') {
      alert('開窗 maintable 不可空白');
    }
    if (this.mainItem === '') {
      alert('開窗 item 不可空白');
    }

  }

  override ngOnInit() {
    super.ngOnInit();
  }

  doCancel(e: any) {
    e?.preventDefault?.();
    e?.stopPropagation?.();
    this.retParams.result = false;
    this.dialogRef.close(this.retParams);
  }

  agRowClicked($event: any) {
    this.selectedItem = $event.data;
  }

  agRowDoubleClicked($event: RowDoubleClickedEvent<any, any>) {
    if (this.isMultiSelect) {
      this.selectedItem = $event.data;
    } else {
      this.selectedItem = $event.data;
      this.doOk($event);
    }
  }

  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      event.preventDefault();
      //let bool = confirm('確定要取消?');
      //if(bool){
        this.doCancel(event);
        //this.doOk(event);
      //}
    }
  }

  onPopState(event: PopStateEvent) {
    let bool = confirm('確定要關閉開窗?');
    if (bool) {
      this.doOk(event);
    }
  }

  onDoOk(e: any) {
    this.doOk(e);
  }

  override async setColumnDisplay(openwinIn: openWinClass) {
    super.setColumnDisplay(openwinIn);
    /*this.columnDefs = [];
    let expr = openwinIn.sqlReturn.split(',');
    if (expr.length >= 2) {
      if (this.keyExpr.length === 0) {
        let keyList = expr[0].split(',');
        this.keyExpr = [...keyList];
      }
      if (openwinIn.displayExpr === '') openwinIn.displayExpr = expr[1];
    }
    let labelList = openwinIn.display.split(CR);
    let fontSize = 14;
    this.columnDefs = this.gridSrv.geneColumnListDisplay(this.columnDefs, labelList, fontSize);
    */
  }


  override onGridReady(event: GridReadyEvent) {
    super.onGridReady(event);
    //this.gridSrv.gridApi = event.api;
    //this.gridSrv.init(this.gridSrv.gridInitOpt);
    //this.gridSrv.setRowSelectionOpt(this.isMultiSelect);
    this.getColumnDefs(this.openwinIn.getOpenWinLoadOption(),true);
  }

  doGetData() {
    this.orm
      .doOpenWin_post(this.type, this.maintable, this.mainItem, this.params, this.sqlWhere, this.sqlOrder)
      .subscribe((data: any) => {
        console.log('doOpenWin_post:',data);
        if (data.result) {
          this.setItemList(data.obj);
          if (this.itemList.length > 0) {
            this.reorderColumn(this.itemList[0], this.columnDefs);
          }
        } else {
          alert(data.errorLog);
        }
      });
  }

  override getColumnDefs(opt: OpenWinLoadOption,isGetData: boolean = true) {
    super.getColumnDefs(opt,isGetData); // 不要用 祖先的
    /*
    this.orm.getopenwin(this.maintable, this.mainItem, 'W').subscribe((data: any) => {
      if (data.result) {
        this.openwinIn.assign(data.obj);
        this.setColumnDisplay(this.openwinIn);
        this.setOrderList(this.openwinIn.order);
        if (isGetData) {
          this.doGetData();
        }
      } else {
        alert(data.errorLog);
      }
    });
    */
  }



  doOk(e: any) {
    this.openwinOut.clear();
    //let keyExpr = this.keyExpr.length > 0 && this.valueExpr() === '' ? this.keyExpr.join(',') : this.valueExpr;

    if (this.retParams) {
      this.retParams.obj.returnData = [];
    }
    try {
      if (this.isMultiSelect) {
        this.selectedRowsData = this.gridApi.getSelectedRows();
      } else {
        this.selectedRowsData = [this.selectedItem];
      }
      for (let i = 0; i < this.selectedRowsData.length; i++) {
        this.openwinOut.returnData.push(this.selectedRowsData[i]);
        if (this.retParams) {
          this.retParams.obj.returnData.push(this.selectedRowsData[i]);
        }
      }
    } catch (error: any) {}

    this.retParams.result = true;
    this.dialogRef.close(this.retParams);
  }

  onRowClick($event: any) {
    try {
      this.focusedRowIndex = $event.rowIndex;
      this.focusedRowKey = $event.key;
    } catch (error: any) {
      alert('onRowClick error:' + error);
    }
  }

  onRowDblClick($event: any) {
    if (!this.isMultiSelect) {
      let e = $event.data;
      if (this.onDoOk) {
        this.onDoOk(e);
      }
      this.onOkClick.emit(e);
    }
  }
  /*
  onSelectionChanged($event: Event) {
    console.log('onSelectionChanged', $event);
    this.selectedRowsData = this.gridApi.getSelectedRows();
  }
  onSumAll() {
    this.gridSrv.onSumAll(this.itemList, this.columnDefs);
  }

  openwinItemStr(): string {
    return `${this.maintable}-${this.mainItem}-${this.type}`;
  }
    */

  override doRefresh() {
    this.orderCompare = this.compareList.find(x => x.id === this.orderCompareId) as idNameItem;
    this.orderItem = this.orderList.find(x => x.id === this.orderItemId) as idNameItem;
    this.sqlOrder = '';
    this.sqlWhere = '';
    let where = '';
    if(this.type !=='W')  // 20250907 add 開窗不管 OpenWin 設定的 where
      where = this.openwinIn.where;
    if(this.orderItem){
      if ((this.orderItem.id !== '') && (this.orderCompare.id !== '')) {
        this.sqlOrder = ' ORDER BY ' + this.orderItem.ps1;
        let ps2 = jkLib.fixString(this.orderItem.ps2);
        this.sqlWhere = where + ' AND ' + jkLib.compare2Sql(this.orderCompareId, ps2, 'string', this.orderWhere);
      }
    }else{
        this.sqlWhere = where ;
    }
    //this.doGetData();
    this.openwinIn.where = this.sqlWhere;
    this.openwinIn.order = this.sqlOrder;
    super.doRefresh();
  }


  override onWindowResize() {
    super.onWindowResize();
  }
}
